import React from 'react';
import { Content } from './Content';
import { PlanDatailsForm } from './Form';
import * as S from './styles';

interface PlanDetailsModalProps {
	open: boolean;
	onCancel: () => void;
}

export function PlanDetailsModal({ open = false, onCancel }: Readonly<PlanDetailsModalProps>) {
	return (
		<S.ModalWrapper
			open={open}
			width="45vw"
			footer={null}
			centered={true}
			onCancel={onCancel}
			style={{ borderRadius: '10px' }}
		>
			<Content>
				<PlanDatailsForm />
			</Content>
		</S.ModalWrapper>
	);
}
